import {
  Baby,
  BedDouble,
  Car,
  CardSim,
  Coffee,
  Flower2,
  Gamepad2,
  Gift,
  Globe,
  House,
  KeyRound,
  LayoutGrid,
  Luggage,
  Package,
  PaintRoller,
  PhoneCall,
  Plane,
  Shirt,
  ShoppingBasket,
  Smartphone,
  Ticket,
  Trophy,
  Tv,
  Utensils,
  Wine,
} from 'lucide-react';
import GiftWrappedIcon from '@/components/icons/gift-wrapped';
import GolfIcon from '@/components/icons/golf';

/*
 * One icon family for every category: lucide-react outlines (plus two custom
 * icons drawn in the same style), a single colour, 1.75 stroke.
 */
export const slugToIconMap = {
  // Gift card categories
  giftcard: LayoutGrid,
  giftcards: LayoutGrid,
  'clothing-and-accessories': Shirt,
  coffee: Coffee,
  entertainment: Ticket,
  flights: Plane,
  gaming: Gamepad2,
  'gifts-for-her': Gift,
  'gifts-for-him': GiftWrappedIcon,
  golf: GolfIcon,
  groceries: ShoppingBasket,
  'health-and-spa': Flower2,
  hotels: BedDouble,
  'house-and-home': House,
  'maternity-and-toys': Baby,
  renovations: PaintRoller,
  'restaurants-and-food': Utensils,
  sports: Trophy,
  travel: Luggage,
  uber: Car,
  'wine-and-cocktails': Wine,
  // Other product types
  topup: Smartphone,
  data: Globe,
  pin: KeyRound,
  digitaltv: Tv,
  bundle: Package,
  esim: CardSim,
  longdistance: PhoneCall,
};

/**
 * Icon for a category slug. Inherits the text colour (`currentColor`) unless
 * `color` is passed. Returns null for an unknown slug.
 */
const CategoryIcon = ({ slug, color, size = 16, style, className }) => {
  const Icon = slugToIconMap[slug];
  if (!Icon) return null;

  return (
    <Icon
      aria-hidden="true"
      className={className}
      color={color || 'currentColor'}
      size={size}
      strokeWidth={1.75}
      style={{ flexShrink: 0, ...style }}
    />
  );
};

export default CategoryIcon;
